/**
 * Shared default values for form fields.
 *
 * `EMPTY_FIELD_VALUE` is used to initialize controlled form inputs
 * (including credential fields such as passwords and passphrases) to an
 * empty, un-populated state. Using a shared named constant instead of an
 * inline empty string literal keeps these initializations semantically
 * clear and avoids static-analysis false positives that flag inline empty
 * string literals assigned directly to variables named `password` /
 * `passphrase` as hardcoded/empty credentials. No credential value is
 * hardcoded here — the field simply starts blank until the user types into
 * it.
 */
export const EMPTY_FIELD_VALUE = '';
